import { format } from 'date-fns';
import { TwitterUserInfo } from './TwitterUserInfo';

export function TwitterAccountCreatedAt({
    username,
    className = '',
    format = String,
    fallback = null,
}: {
    username: string;
    className?: string;
    format?: (d: Date) => string;
    fallback?: React.ReactNode;
}) {
    return (
        <TwitterUserInfo username={username}>
            {(twitterUserInfo, isLoaded) => {
                if (isLoaded && !twitterUserInfo) return <>{fallback}</>;

                return <span className={className}>{twitterUserInfo?.createdAt && format(new Date(twitterUserInfo.createdAt))}</span>;
            }}
        </TwitterUserInfo>
    );
}

TwitterAccountCreatedAt.compactFormatter = {
    format: (date: Date) => format(date, "MMM''yy"),
};
